import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import AuthContext from "./AuthContext";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import FeedBack from "./pages/FeedBack";
import FeedbackList from "./pages/FeedbackList";
import Register from "./pages/Register";
import Login from "./pages/Login";
import TermsAndConditions from "./pages/termAndConditions";
import Profile from "./pages/Profile";
import ChangePassword from "./pages/ChangePassword";
import QueueManager from "./pages/QueueManager";
import DemoQueueManager from "./pages/DemoQueueManager";
import OtherProducts from "./pages/OtherProducts";
import About from "./pages/About";
import InstallPrompt from "./components/InstallPrompt";

// Redirect logged-in users away from the home page to /queue
function HomeOrQueue() {
  const { isLoggedIn } = useContext(AuthContext);
  return isLoggedIn ? <Navigate to="/queue" replace /> : <HomePage />;
}

// Routes where the top Navbar should be hidden (full-screen tablet UI)
const NO_NAVBAR_PATHS = ["/queue", "/demo-queue"];

function AppLayout() {
  const location = useLocation();
  const showNavbar = !NO_NAVBAR_PATHS.includes(location.pathname);

  return (
    <div className="App bg-white">
      {showNavbar && <Navbar />}
      <InstallPrompt />
      <Routes>
        {/* Main pages */}
        <Route path="/" element={<HomeOrQueue />} />
        <Route path="/feedback" element={<FeedBack />} />
        <Route path="/feedbacklist" element={<FeedbackList />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/other-products" element={<OtherProducts />} />
        <Route path="/about" element={<About />} />

        {/* Unified single-screen queue manager */}
        <Route path="/queue" element={<QueueManager />} />

        {/* Unified demo */}
        <Route path="/demo-queue" element={<DemoQueueManager />} />

        {/* Redirect old routes to the unified queue screen */}
        <Route path="/dashboard" element={<Navigate to="/queue" replace />} />
        <Route path="/customer-check-in" element={<Navigate to="/queue" replace />} />
        <Route path="/admin" element={<Navigate to="/queue" replace />} />
        <Route path="/display-queue" element={<Navigate to="/queue" replace />} />

        {/* Redirect old demo routes */}
        <Route path="/Demo-Dashboard" element={<Navigate to="/demo-queue" replace />} />
        <Route path="/demo-dashboard" element={<Navigate to="/demo-queue" replace />} />
        <Route path="/Demo-display-queue" element={<Navigate to="/demo-queue" replace />} />
        <Route path="/Demo-customer-check-in" element={<Navigate to="/demo-queue" replace />} />
        <Route path="/Demo-admin" element={<Navigate to="/demo-queue" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
